import CountUp from "react-countup";
import { GiHiking, GiMountainRoad } from "react-icons/gi";
import { FaPeopleRoof } from "react-icons/fa6";
import { ImMakeGroup } from "react-icons/im";

const StatisticComponent = () => {
  return (
    <div className="bg-banner-1-image min-h-[450px] lg:min-h-[350px] bg-cover bg-center relative w-full rounded-lg">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Centered Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center z-10 text-center px-4">
        <div className="text-white text-2xl sm:text-4xl max-w-[600px]">
          Since we started, we have managed to cover many hikes and adventures
        </div>

        {/* Responsive Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 my-12 w-full max-w-5xl">
          {[
            {
              icon: <GiHiking color="white" size={60} />,
              count: 100,
              label: "Total Hikes",
            },
            {
              icon: <FaPeopleRoof color="white" size={60} />,
              count: 320,
              label: "Clients",
            },
            {
              icon: <GiMountainRoad color="white" size={60} />,
              count: 28,
              label: "Destinations",
            },
            {
              icon: <ImMakeGroup color="white" size={60} />,
              count: 13,
              label: "Programmes",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center px-3 lg:px-6 py-4 border border-white rounded-lg shadow-lg"
            >
              <div className="my-2">{item.icon}</div>
              <CountUp
                end={item.count}
                duration={5}
                className="text-4xl sm:text-6xl font-bold text-white"
              />
              <div className="text-white mt-1">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatisticComponent;
